import documentComments from "./document-comments";
import documentProject from "./document-project";
import { combineReducers } from "redux";

export default combineReducers({
  documentComments,
  documentProject,
});
